import {
  ADJUST_TEAM_ATTENDANCE_REQUEST_ERROR,
  ADJUST_TEAM_ATTENDANCE_REQUEST_PENDING,
  ADJUST_TEAM_ATTENDANCE_REQUEST_SUCCESS,
  ADJUST_TEAM_OVERTIME_REQUEST_ERROR,
  ADJUST_TEAM_OVERTIME_REQUEST_PENDING,
  ADJUST_TEAM_OVERTIME_REQUEST_SUCCESS,
  CLEAR_DROPDOWN_FILTER,
  GET_ADJUST_TEAM_ATTENDANCE_DETAILS_ERROR,
  GET_ADJUST_TEAM_ATTENDANCE_DETAILS_PENDING,
  GET_ADJUST_TEAM_ATTENDANCE_DETAILS_SUCCESS,
  GET_ADJUST_TEAM_OVERTIME_DETAILS_ERROR,
  GET_ADJUST_TEAM_OVERTIME_DETAILS_PENDING,
  GET_ADJUST_TEAM_OVERTIME_DETAILS_SUCCESS,
  GET_TEAM_ATTENDANCE_DETAILS,
  GET_TEAM_ATTENDANCE_LIST_ERROR,
  GET_TEAM_ATTENDANCE_LIST_PENDING,
  GET_TEAM_ATTENDANCE_LIST_SUCCESS,
  SET_ADJUST_TEAM_ATTENDANCE_DETAILS,
  SET_ADJUST_TEAM_ATTENDANCE_REQUEST_INITIAL_STATE,
  SET_ADJUST_TEAM_OVERTIME_DETAILS,
  SET_ADJUST_TEAM_OVERTIME_REQUEST_INITIAL_STATE,
  SET_TEAM_ATTENDANCE_LIST,
  SET_DROPDOWN_FILTER_COUNTRY,
  SET_DROPDOWN_FILTER_EMPLOYEE,
  SET_MY_SUBORDINATE_LIST_ASYNC,
  SET_SELECTED_TEAM_ATTENDANCE_DATE,
  SET_SELECTED_SUBORDINATE_DETAILS,
  SET_TEAM_ATTENDANCE_DATE_LIST,
  SET_TEAM_ATTENDANCE_DEDUCTION_DETAILS,
  GET_TEAM_ATTENDANCE_DEDUCTION_DETAILS_PENDING,
  GET_TEAM_ATTENDANCE_DEDUCTION_DETAILS_SUCCESS,
  GET_TEAM_ATTENDANCE_DEDUCTION_DETAILS_ERROR,
  ADJUST_TEAM_DEDUCTION_REQUEST_PENDING,
  ADJUST_TEAM_DEDUCTION_REQUEST_SUCCESS,
  ADJUST_TEAM_DEDUCTION_REQUEST_ERROR,
  SET_TEAM_DEDUCTION_REQUEST_INITIAL_STATE,
  SET_DISTINCT_SITE_LIST,
  GET_TEAM_SUMMARY_LIST_PENDING,
  GET_TEAM_SUMMARY_LIST_SUCCESS,
  GET_TEAM_SUMMARY_LIST_ERROR,
  SET_TEAM_SUMMARY_LIST,
} from './constants';

const INIT_STATE = {
  attendanceList: [],
  attendanceDetails: {},
  isGetAttendanceListPending: false,
  selectedDateRange: null,
  saveOverTimeRequestStatus: '',
  saveOverTimeRequestErrorMessages: '',
  adjustOverTimeDetails: {},
  isGetAdjustOverTimeDetailsPending: false,
  saveAttendanceRequestStatus: '',
  saveAttendanceRequestErrorMessages: '',
  adjustAttendanceDetails: {},
  isGetAdjustAttendanceDetailsPending: false,
  subordinateList: [],
  selectedCountry: {},
  selectedEmployee: {},
  subordinateUserDetails: null,
  dateList: [],
  teamAttendanceDeductionDetails: {},
  isGetTeamAttendanceDeductionDetailsPending: false,
  saveDeductionRequestStatus: '',
  saveDeductionRequestErrorMessages: '',
  sites: [],
};

export default (localState = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TEAM_ATTENDANCE_LIST_PENDING: {
      return {
        ...localState,
        isGetAttendanceListPending: true,
      };
    }
    case GET_TEAM_ATTENDANCE_LIST_SUCCESS: {
      return {
        ...localState,
        isGetAttendanceListPending: false,
      };
    }
    case GET_TEAM_ATTENDANCE_LIST_ERROR: {
      return {
        ...localState,
        isGetAttendanceListPending: false,
      };
    }
    case SET_TEAM_ATTENDANCE_LIST: {
      return {
        ...localState,
        attendanceList: action.payload,
      };
    }
    case GET_TEAM_ATTENDANCE_DETAILS: {
      return {
        ...localState,
        attendanceDetails: localState.attendanceList.find((item) => {
          return item.taId === action.payload;
        }),
      };
    }
    case SET_SELECTED_TEAM_ATTENDANCE_DATE: {
      return {
        ...localState,
        selectedDateRange: action.payload,
      };
    }
    case SET_ADJUST_TEAM_OVERTIME_REQUEST_INITIAL_STATE: {
      return {
        ...localState,
        saveOverTimeRequestStatus: '',
        saveOverTimeRequestErrorMessages: '',
      };
    }
    case ADJUST_TEAM_OVERTIME_REQUEST_PENDING: {
      return {
        ...localState,
        saveOverTimeRequestStatus: 'PENDING',
        saveOverTimeRequestErrorMessages: '',
      };
    }
    case ADJUST_TEAM_OVERTIME_REQUEST_SUCCESS: {
      return {
        ...localState,
        saveOverTimeRequestStatus: 'SUCCESS',
      };
    }
    case ADJUST_TEAM_OVERTIME_REQUEST_ERROR: {
      return {
        ...localState,
        saveOverTimeRequestStatus: 'ERROR',
        saveOverTimeRequestErrorMessages: action.payload,
      };
    }
    case SET_ADJUST_TEAM_ATTENDANCE_REQUEST_INITIAL_STATE: {
      return {
        ...localState,
        saveAttendanceRequestStatus: '',
        saveAttendanceRequestErrorMessages: '',
      };
    }
    case ADJUST_TEAM_ATTENDANCE_REQUEST_PENDING: {
      return {
        ...localState,
        saveAttendanceRequestStatus: 'PENDING',
        saveAttendanceRequestErrorMessages: '',
      };
    }
    case ADJUST_TEAM_ATTENDANCE_REQUEST_SUCCESS: {
      return {
        ...localState,
        saveAttendanceRequestStatus: 'SUCCESS',
      };
    }
    case ADJUST_TEAM_ATTENDANCE_REQUEST_ERROR: {
      return {
        ...localState,
        saveAttendanceRequestStatus: 'ERROR',
        saveAttendanceRequestErrorMessages: action.payload,
      };
    }
    case GET_ADJUST_TEAM_OVERTIME_DETAILS_PENDING: {
      return {
        ...localState,
        isGetAdjustOverTimeDetailsPending: true,
      };
    }
    case GET_ADJUST_TEAM_OVERTIME_DETAILS_SUCCESS: {
      return {
        ...localState,
        isGetAdjustOverTimeDetailsPending: false,
      };
    }
    case GET_ADJUST_TEAM_OVERTIME_DETAILS_ERROR: {
      return {
        ...localState,
        isGetAdjustOverTimeDetailsPending: false,
      };
    }
    case SET_ADJUST_TEAM_OVERTIME_DETAILS: {
      return {
        ...localState,
        adjustOverTimeDetails: action.payload,
      };
    }
    case GET_ADJUST_TEAM_ATTENDANCE_DETAILS_PENDING: {
      return {
        ...localState,
        isGetAdjustAttendanceDetailsPending: true,
      };
    }
    case GET_ADJUST_TEAM_ATTENDANCE_DETAILS_SUCCESS: {
      return {
        ...localState,
        isGetAdjustAttendanceDetailsPending: false,
      };
    }
    case GET_ADJUST_TEAM_ATTENDANCE_DETAILS_ERROR: {
      return {
        ...localState,
        isGetAdjustAttendanceDetailsPending: false,
      };
    }
    case SET_ADJUST_TEAM_ATTENDANCE_DETAILS: {
      const { schedIn, schedOut } = localState.attendanceList.find((item) => {
        return item.taId === action.payload.taId;
      });
      const { timeIn, timeOut } = action.payload;
      return {
        ...localState,
        adjustAttendanceDetails: {
          ...action.payload,
          schedIn,
          schedOut,
          clockIn: timeIn ?? schedIn,
          clockOut: timeOut ?? schedOut,
        },
      };
    }
    case SET_MY_SUBORDINATE_LIST_ASYNC: {
      const { subordinateList } = action.payload;
      return {
        ...localState,
        subordinateList,
      };
    }
    case SET_DROPDOWN_FILTER_COUNTRY: {
      return {
        ...localState,
        selectedCountry: action.payload,
      };
    }
    case SET_DROPDOWN_FILTER_EMPLOYEE: {
      return {
        ...localState,
        selectedEmployee: action.payload,
      };
    }
    case CLEAR_DROPDOWN_FILTER: {
      return {
        ...localState,
        selectedCountry: {},
        selectedEmployee: {},
        subordinateUserDetails: {},
      };
    }
    case SET_SELECTED_SUBORDINATE_DETAILS: {
      return {
        ...localState,
        subordinateUserDetails: action.payload,
      };
    }
    case SET_TEAM_ATTENDANCE_DATE_LIST: {
      return {
        ...localState,
        dateList: action.payload,
      };
    }
    case SET_TEAM_ATTENDANCE_DEDUCTION_DETAILS: {
      return {
        ...localState,
        teamAttendanceDeductionDetails: action.payload,
      };
    }
    case GET_TEAM_ATTENDANCE_DEDUCTION_DETAILS_PENDING: {
      return {
        ...localState,
        isGetTeamAttendanceDeductionDetailsPending: true,
      };
    }
    case GET_TEAM_ATTENDANCE_DEDUCTION_DETAILS_SUCCESS: {
      return {
        ...localState,
        isGetTeamAttendanceDeductionDetailsPending: false,
      };
    }
    case GET_TEAM_ATTENDANCE_DEDUCTION_DETAILS_ERROR: {
      return {
        ...localState,
        isGetTeamAttendanceDeductionDetailsPending: false,
      };
    }
    case ADJUST_TEAM_DEDUCTION_REQUEST_PENDING: {
      return {
        ...localState,
        saveDeductionRequestStatus: 'PENDING',
        saveDeductionRequestErrorMessages: '',
      };
    }
    case ADJUST_TEAM_DEDUCTION_REQUEST_SUCCESS: {
      return {
        ...localState,
        saveDeductionRequestStatus: 'SUCCESS',
      };
    }
    case ADJUST_TEAM_DEDUCTION_REQUEST_ERROR: {
      return {
        ...localState,
        saveDeductionRequestStatus: 'ERROR',
        saveDeductionRequestErrorMessages: action.payload,
      };
    }
    case SET_TEAM_DEDUCTION_REQUEST_INITIAL_STATE: {
      return {
        ...localState,
        saveDeductionRequestStatus: '',
        saveDeductionRequestErrorMessages: '',
      };
    }
    case SET_DISTINCT_SITE_LIST: {
      const { sites } = action.payload;
      return {
        ...localState,
        sites,
      };
    }
    case GET_TEAM_SUMMARY_LIST_PENDING: {
      return {
        ...localState,
        isGetSummaryListPending: true,
      };
    }
    case GET_TEAM_SUMMARY_LIST_SUCCESS: {
      return {
        ...localState,
        isGetSummaryListPending: false,
      };
    }
    case GET_TEAM_SUMMARY_LIST_ERROR: {
      return {
        ...localState,
        isGetSummaryListPending: false,
      };
    }
    case SET_TEAM_SUMMARY_LIST: {
      return {
        ...localState,
        summaryList: action.payload,
      };
    }
    default:
      return { ...localState };
  }
};
